import { createSelector } from '@ngrx/store';
import { selectCategoriesMap, selectLocalitiesMap } from '../../selectors';
import { selectJobseekerStoreState } from '../jobseeker-profile/selectors';

export const selectJobseekerSubscriptionStoreState = createSelector(
    selectJobseekerStoreState,
    s => s.subscription
);

export const selectJobseekerSubscriptionLookup = createSelector(
    selectJobseekerSubscriptionStoreState,
    (s) => s?.jobseekerSubscriptionLookup
);

export const selectJobseekerSubscriptionSpecializations = createSelector(
  selectJobseekerSubscriptionLookup,
  (s) => s?.specializations
    ? [...s.specializations].sort((a, b) =>
        a.name.localeCompare(b.name)
      )
    : []
);

export const selectJobseekerSelectedSpecializationIds = createSelector(
    selectJobseekerSubscriptionStoreState,
    (s) => s?.selectedSpecializations?.map(v => v.id) ?? []
);

export const selectJobseekerSelectedSpecializationsMap = createSelector(
    selectJobseekerSelectedSpecializationIds,
    selectJobseekerSubscriptionLookup,
    (selectedIds, lookup) => {
        if (!lookup) return null;

        const result = lookup.specializations.reduce((acc, spec) => {
            acc[spec.id] = false;
            return acc;
        }, {} as Record<string, boolean>);

        selectedIds?.forEach(id => {
            result[id] = true;
        });

        return result;
    }
);

export const selectJobseekerAtLeastOneSpecializationSelected = createSelector(
    selectJobseekerSelectedSpecializationIds,
    (ids) => ids.length > 0
);

export const selectJobseekerSpecializationTouched = createSelector(
    selectJobseekerSubscriptionStoreState,
    (s) => s?.specializationsTouched
);

export const selectSubscriptionSpecializations = createSelector(
    selectJobseekerSubscriptionStoreState,
    (s) => s?.selectedSpecializations
);

export const selectSubscriptionLocations = createSelector(
    selectJobseekerSubscriptionStoreState,
    (s) => s?.selectedLocations
);

export const selectSubscriptionSeniorityLevels = createSelector(
    selectJobseekerSubscriptionStoreState,
    (s) => s?.selectedSeniorityLevels
);

export const selectIsEditModeOn = createSelector(
    selectJobseekerSubscriptionStoreState,
    s => s.isEditMode
);

export const selectJobseekerSubscriptionIsLoading = createSelector(
    selectJobseekerSubscriptionStoreState,
    s => s.loading
);

export const selectSubscriptionFormInitialValue = createSelector(
    selectJobseekerSubscriptionStoreState,
    s => {
        const sub = s.subscription;
        return sub && {
            localities: sub?.locations?.map(c => c.id),
            seniorityLevels: sub?.seniorityLevels?.map((v) => v.id)
        };
    }
);